module.exports = __webpack_public_path__ + "img/model_24_zh.85c8057a.jpg";